﻿import { projectSettings } from "../../config";

import LandingPage from "./LandingPage.svelte";

const title = projectSettings.classActionName;

const registrationPageList = [
    {
        pageIndex: 0,
        component: LandingPage,
        title: "REGISTRATION FORM",
        showInTracker: false,
        routeId: "/Registration",
        properties: {
            pageTitle: `${title}`,
            lastVisitedPage: "Landing Page",
        },
    },
];

export default registrationPageList
